import { fetchApi } from '@/config/axiosSetting';
import { SignatureQueryParamsType } from '@/modules/adjusterReportModules/types/signatureQueryParams.type';

export const patchPropertyCulpritSignatureQueryFunction = (
  params: Omit<SignatureQueryParamsType, 'damagedId'>,
): Promise<{}> => {
  return fetchApi({
    method: 'patch',
    url: `/property/reports/${params.id}/accident_users/culprit/images/signature/`,
    data: params.data,
  });
};
